import React from 'react';
import { Edit, SimpleForm, TextInput} from 'react-admin'

const VendorEdit = (props: any) => {
    return (
        <Edit {...props}>
            <SimpleForm>
                <TextInput source='name' />
                <TextInput source='phoneNumber' />
                <TextInput source='category' />
            </SimpleForm>
        </Edit>
    );
};

export default VendorEdit;